import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import * as PropTypes from "prop-types";
import { SearchkitComponent, SortingAccessor, renderComponent, RenderComponentPropType } from "../../../../core";
import { Select } from "../../../ui";

var defaults = require("lodash/defaults");

export var SortingSelector =
/*#__PURE__*/
function (_SearchkitComponent) {
  _inherits(SortingSelector, _SearchkitComponent);

  function SortingSelector() {
    _classCallCheck(this, SortingSelector);

    return _possibleConstructorReturn(this, _getPrototypeOf(SortingSelector).apply(this, arguments));
  }

  _createClass(SortingSelector, [{
    key: "defineAccessor",
    value: function defineAccessor() {
      return new SortingAccessor("sort", {
        options: this.props.options
      });
    }
  }, {
    key: "toggleItem",
    value: function toggleItem(key) {
      this.accessor.state = this.accessor.state.setValue(key);
      this.searchkit.performSearch();
    }
  }, {
    key: "setItems",
    value: function setItems(keys) {
      this.toggleItem(keys[0]);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      if (!this.accessor) return null;
      var listComponent = this.props.listComponent;
      var options = this.accessor.options.options;
      var selected = [this.accessor.getSelectedOption().key];
      var disabled = !this.hasHits();
      return renderComponent(listComponent, {
        mod: this.props.mod,
        className: this.props.className,
        items: options,
        selectedItems: selected,
        setItems: this.setItems.bind(this),
        toggleItem: this.toggleItem.bind(this),
        disabled: disabled,
        urlBuilder: function urlBuilder(item) {
          return _this.accessor.urlWithState(item.key);
        },
        translate: this.translate
      });
    }
  }]);

  return SortingSelector;
}(SearchkitComponent);
SortingSelector.propTypes = defaults({
  listComponent: RenderComponentPropType,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    field: PropTypes.string,
    order: PropTypes.string,
    defaultOption: PropTypes.bool
  }))
}, SearchkitComponent.propTypes);
SortingSelector.defaultProps = {
  listComponent: Select
};